<ds-table-component
  [columns]="columns()"
  [data]="rows()"
  [caption]="caption()"
  [hideCaption]="true"
  [emptyState]="dsEmptyState()"
  [manualSorting]="true"
  [sortColumnKey]="sortColumnKey()"
  [sortDirection]="sortDirection()"
  [withPagination]="true"
  (onSort)="sortChange.emit($event)"
></ds-table-component>
<ds-pagination-v2
  [ariaLabel]="paginationAriaLabel()"
  [page]="page()"
  [pageSize]="pageSize()"
  [collectionSize]="collectionSize()"
  [pageSizeOptions]="pageSizeOptions()"
  [paginationForTable]="true"
  (pageChange)="pageChange.emit($event)"
  (pageSizeChange)="pageSizeChange.emit($event)"
></ds-pagination-v2>

<ng-template #addonsCellTemplate let-cell="cell">
  <ul class="list-unstyled mb-0">
    @for (addon of getAddonLines(cell); track $index) {
      <li>{{ addon }}</li>
    }
  </ul>
</ng-template>

<ng-template #statusCellTemplate let-cell="cell" let-row="row" let-colKey="colKey">
  @if (cell?.button; as button) {
    <button
      type="button"
      ds-button
      [variant]="button.variant ?? DsButtonVariants.tertiary"
      [attr.aria-label]="button.ariaLabel ?? null"
      (click)="button.onClick?.(row, colKey, $event)"
    >
      {{ button.label }}
    </button>
  } @else if (cell?.value) {
    <span>
      @if (isConfigured(cell)) {
        <ds-icon [icon]="Icons.Check" aria-hidden="true"></ds-icon>
      }
      {{ cell.value }}
    </span>
  }
</ng-template>
